import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LuSelectBaseOptions, LuSelectType } from '../../lu-select.models';
import LuSelectItem from '../lu-select-item';

export class LuSelectItemBasicOptions extends LuSelectBaseOptions {
	primaryField: IItemBasicPrimaryField;
	type: LuSelectType = LuSelectType.BASIC;

	constructor(primaryField: IItemBasicPrimaryField) {
		super();
		this.primaryField = primaryField;
	}
}

export interface IItemBasicPrimaryField {
	field: string;
	class?: string;
	formatter?: any;
}

interface Field {
	value: string;
	class?: string;
}

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-select-item-basic',
	templateUrl: './lu-select-item-basic.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LuSelectItemBasicComponent extends LuSelectItem implements OnInit {
	options: LuSelectItemBasicOptions;
	labelField: Field;
	selectedItem: boolean;

	constructor() {
		super();
	}

	ngOnInit(): void {
		this.labelField = this.buildField();
	}

	buildField(): Field {
		let value = '';
		if (!!this.options.primaryField.formatter) {
			value = this.options.primaryField.formatter(this.data, this.data[this.options.primaryField.field]);
		} else {
			value = this.data[this.options.primaryField.field];
		}

		return {
			value,
			class: this.options.primaryField.class
		};
	}
}
